'use client'

import React from 'react'
import {
  GlobalProvider,
  UserData,
  MerchantData,
} from './contexts/globalcontext'

interface ServerData {
  getAllMenuCat?: unknown[]
  getBranches?: unknown[]
  getAllTaxes?: unknown[]
  getAllOptions?: unknown[]
  getMenus?: unknown[]
  getPlans?: unknown[]
  getTownship?: unknown[]
  // add all other expected keys here...
  getActiveBranches?: unknown[]
}
interface GlobalClientProviderProps {
  children: React.ReactNode
  initialToken?: string | null
  initialUser?: UserData | null
  initialMerchant?: MerchantData | null
  serverData?: ServerData
}

export default function GlobalClientProvider({
  children,
  initialToken,
  initialUser,
  initialMerchant,
  serverData = {}, // default empty object
}: GlobalClientProviderProps) {
  return (
    <GlobalProvider
      initialToken={initialToken}
      initialUser={initialUser}
      initialMerchant={initialMerchant}
      serverData={serverData}
    >
      {children}
    </GlobalProvider>
  )
}
